<template >
  <div
    class="navbar-item has-text-grey-dark has-back-button cursor-link"
    @click="goPrevious"
  >
    <!-- style="padding-left:1rem" -->
    <span class="icon" :class="iconSize">
      <i class="mdi" :class="[icon, size]"></i>
    </span>
    <!-- <transition name="fade" mode="out-in">
      <span style="padding-left: 2px" :key="$route.fullPath" class="is-size-6">{{ buttonName | capitalize }}</span>
    </transition> -->
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      default: "mdi-arrow-left"
    },
    size: {
      type: String,
      default: "mdi-24px"
    },
    iconSize: {
      type: String,
      default: "is-normal"
    }
  },
  methods: {
    goPrevious() {
      this.$analytics.logEvent('hit_nav_button', { page_name: this.$route.name, button_name: 'back_btn' })

      const firstVisit = localStorage.getItem("firstVisit");
      if (firstVisit) {
        localStorage.removeItem("firstVisit");
        this.$router.push({ name: "home", params: {cityName: this.$store.state.user.userCity} });
      } else {
        this.$router.go(-1);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.has-back-button {
  width: 48px;
}
</style>